import { swedishWeekdayFullNameLookup } from "@@/shared/parse-weekly-schedule";
import { sortBy } from "@@/utilities/sort";
import { dateAgnosticTimeRangeToString } from "./date-agnostic-time-range-to-string";
import { daysWithAvailability } from "./days-with-availability";
import type { WeekAvailability } from "./week-availability";

const weekAvailabilityByDayToString = (availability: WeekAvailability) => {
    const week = availability.week;
    return daysWithAvailability(week).map(day => {
        if (!week) throw new Error("week cannot be undefined");
        // week day exists since week exists and daysWithAvailability has
        // shown us the day exists in week
        const ranges = week[day]!.sort(sortBy(item => item.start.hour)).map(
            range =>
                dateAgnosticTimeRangeToString(range, {
                    ignoreMinutesIfZero: true,
                }),
        );
        return `${swedishWeekdayFullNameLookup[day]} ${ranges.join(", ")}`;
    });
};

export { weekAvailabilityByDayToString };
